export const routes = {
  Copy: '/copy',
  Create: '/create',
  Admin: '/admin/:linkId',
};
